import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	background-color: ${vars.colorBackgroundContrastDark};
	overflow: hidden;
`;
